<template>
  <div v-if="nextStage">
    <div v-if="open" class="fixed inset-0">
      <div class="absolute inset-0" @click="open = !open"></div>
    </div>
    <div class="inline-flex rounded-md shadow-sm">
      <button
        type="button"
        data-track="clicked-primary-contact-stage-update-button"
        class="relative inline-flex items-center rounded-l-md bg-amber-300 px-3 py-2 text-sm font-semibold text-slate-900 hover:bg-amber-400 focus:z-10"
        @click="updateContactStage(nextStage)"
      >
        Move to {{ nextStage }}
      </button>
      <div class="relative -ml-px block">
        <button
          id="option-menu-button"
          type="button"
          class="relative inline-flex items-center rounded-r-md bg-amber-300 px-2 py-2 text-slate-900 hover:bg-amber-400 focus:z-10"
          aria-expanded="true"
          aria-haspopup="true"
          @click="open = !open"
        >
          <span class="sr-only">Other options</span>
          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path
              fill-rule="evenodd"
              d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
              clip-rule="evenodd"
            />
          </svg>
        </button>

        <div
          v-if="open"
          class="absolute right-0 z-10 -mr-1 mt-2 w-56 origin-top-right rounded-md bg-white shadow-md focus:outline-none"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="option-menu-button"
          tabindex="-1"
        >
          <div class="py-1" role="none">
            <button
              v-for="stage in stages"
              :key="stage"
              class="text-left text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900 w-full"
              role="menuitem"
              tabindex="-1"
              @click="updateContactStage(stage)"
            >
              Move to {{ stage }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const stages = [
  'Applied',
  'Phone Screen',
  'Interview',
  'Onboarding',
  'Hired',
  'Disqualified',
  'Nurture',
  'Unlicensed',
  'Unlicensed with Coursework Started',
  'Declined',
];

export default {
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      open: false,
      stages,
    };
  },
  computed: {
    nextStage() {
      switch (this.contact.stage) {
        case 'Applied':
          return 'Phone Screen';
        case 'Phone Screen':
          return 'Interview';
        case 'Nurture':
          return 'Interview';
        case 'Interview':
          return 'Onboarding';
        case 'Onboarding':
          return 'Hired';
      }
    },
  },
  methods: {
    updateContactStage(stage) {
      if (stage === 'Disqualified') {
        this.$emit('disqualify-candidate');
      } else if (stage === 'Onboarding') {
        this.$emit('onboard-candidate');
      } else {
        const self = this;
        self.$store.commit('general/showLocalLoadingSpinner');
        fetch(`/api/contacts/${self.contact.id}`, {
          method: 'PUT',
          body: JSON.stringify({
            stage: stage,
          }),
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
          },
        })
          .then(response => {
            return response.json();
          })
          .then(async data => {
            self.$store.commit('general/hideLocalLoadingSpinner');
            if (data.status != 'error') {
              await self.$router.go();
              self.$store.commit('general/showAlert', {
                alertType: 'success',
                alertTitle: 'Candidate stage updated',
                alertDescription:
                  "Your candidate's stage was successfully updated.  Use the button below to dismiss this alert.",
              });
            } else {
              self.$store.commit('general/showAlert', {
                alertType: 'error',
                alertTitle: 'Candidate stage error',
                alertDescription: data.message,
              });
            }
          });
      }
    },
  },
};
</script>
